import React from 'react';
import Logo from '../../assets/image/Logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { routes } from '../../contant';

const Sidebar = ({ setActiveSection, activeSection }) => {
  const navigate = useNavigate();

  const handleNavigation = (section) => {
    setActiveSection(section);
  };

  const logout = () => {
    localStorage.removeItem('token');
    navigate(routes.signin);
  };

  return (
    <div className='w-64 bg-white shadow h-full'>
      <div className='px-6 py-2'>
        <img
          src={Logo}
          style={{  cursor: 'pointer' }}
          alt='Logo'
          onClick={() => {
            navigate('/admin-dashboard');
            handleNavigation('Dashboard');
          }}
          className='w-25 h-18 ' // Adjust size for mobile
        />
      </div>
      <ul className='space-y-2'>
        <li
          className={`flex items-center space-x-2 p-4 rounded cursor-pointer ${
            activeSection === 'Dashboard'
              ? 'bg-blue-100 text-blue-500'
              : 'hover:bg-gray-200'
          }`}
          onClick={() => handleNavigation('Dashboard')}
        >
          <i className='fas fa-tachometer-alt'></i>
          <span>Dashboard</span>
        </li>
        <li
          className={`flex items-center space-x-2 p-4 rounded cursor-pointer ${
            activeSection === 'Users'
              ? 'bg-blue-100 text-blue-500'
              : 'hover:bg-gray-200'
          }`}
          onClick={() => handleNavigation('Users')}
        >
          <i className='fas fa-users'></i>
          <span>Users</span>
        </li>
        <li
          className={`flex items-center space-x-2 p-4 rounded cursor-pointer ${
            activeSection === 'ActivityPoints'
              ? 'bg-blue-100 text-blue-500'
              : 'hover:bg-gray-200'
          }`}
          onClick={() => handleNavigation('ActivityPoints')}
        >
          <i className='fas fas fa-chart-line'></i>
          <span>Activity Points</span>
        </li>

        <li
          className={`flex items-center space-x-2 p-4 rounded cursor-pointer ${
            activeSection === 'Company'
              ? 'bg-blue-100 text-blue-500'
              : 'hover:bg-gray-200'
          }`}
          onClick={() => handleNavigation('Company')}
        >
          <i className='fas fa-building'></i> {/* Company Icon */}
          <span>Company</span>
        </li>
        <li
          className={`flex items-center space-x-2 p-4 rounded cursor-pointer ${
            activeSection === 'Request'
              ? 'bg-blue-100 text-blue-500'
              : 'hover:bg-gray-200'
          }`}
          onClick={() => handleNavigation('Request')}
        >
          <i className='fas fa-file-alt'></i>
          <span>Request</span>
        </li>
      </ul>
      <div className='absolute bottom-4 left-6'>
        <button
          onClick={logout}
          className='text-red-500'
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
